import * as React from 'react';
import { connect } from 'react-redux';
import NotifyHOC from '../../../HOC/Notifications';
import { ILocation } from '../../../interface/common.interface';
import { IApplicationState } from '../../../reducers';

import { paymentType, planType, planColumns } from '../../../mapping/plan';
import { push } from 'connected-react-router';
import { CHECKOUT } from '../../../constants/routes';
import { STATIC_STORAGE_URL } from '@nexxt/common/constants';

interface PlanningProps {
    changePath: (path: string) => void;
}

interface PlanningStates {
    paymentMonthly: string;
    hoverPlan: string;
    maxShow: number;
    selectedPlan: string;
    confirm: boolean;
}
class PlanningBilling extends React.Component<PlanningProps, PlanningStates> {
    state = {
        //state is by default an object
        paymentMonthly: 'monthly',
        hoverPlan: '',
        maxShow: 5,
        selectedPlan: '',
        confirm: false
    };

    confirmPlan = (plan: string, click: boolean) => {
        let confirm = this.state.confirm;
        if (this.state.selectedPlan !== plan) {
            confirm = false;
        }

        if (this.state.hoverPlan === this.state.selectedPlan && confirm) {
            //goto payment
            console.log('GOTO Payment page');
            this.props.changePath(CHECKOUT);
        }

        if (click) {
            //goto payment page
            this.setState({
                confirm: true,
                selectedPlan: plan,
                hoverPlan: plan
            });
        } else {
            this.setState({
                hoverPlan: plan
            });
        }
    };

    renderPaymentType = () => {
        return paymentType.map((p, i) => {
            return (
                <button
                    key={i}
                    className={`plan-table-duration-toggle ${
                        this.state.paymentMonthly === p.value ? 'active' : ''
                    }`}
                    onClick={(e) => this.setState({ paymentMonthly: p.value })}
                >
                    {p.label}
                </button>
            );
        });
    };

    renderColumnHeader = () => {
        return planType.map((s, i) => {
            const { plan, tagline, price } = s.title;
            return (
                <td
                    key={i}
                    className={`plan-spec ${
                        this.state.hoverPlan === s.title.plan
                            ? `${
                                  this.state.selectedPlan === s.title.plan &&
                                  this.state.confirm
                                      ? 'active selected'
                                      : 'active'
                              }`
                            : ''
                    }`}
                    onMouseOver={(e) =>
                        !this.state.confirm && this.confirmPlan(plan, false)
                    }
                >
                    <th key={i}>
                        <p className="plan-title">{plan}</p>
                        <p className="plan-tagline">{tagline}</p>
                        <p className="plan-price">
                            $ <span className="plan-price-price">{price}</span>{' '}
                            <span className="plan-price-duration">/mo</span>
                        </p>
                        <button
                            className="plan-button"
                            onClick={(e) => this.confirmPlan(plan, true)}
                        >
                            Get {plan}
                        </button>
                    </th>
                </td>
            );
        });
    };

    renderRowHeader = () => {
        return planColumns.map((c, i) => {
            if (i < this.state.maxShow) {
                return (
                    <tr className="plan-table-rowHeader" key={c.name}>
                        {c.header}
                    </tr>
                );
            }
        });
    };

    renderTableData = () => {
        return planType.map((s, i) => {
            const value = planColumns.map((c, i) => {
                if (i < this.state.maxShow) {
                    if (typeof s[c.name] === 'boolean') {
                        return (
                            <tr key={c.name}>
                                {s[c.name] ? (
                                    <div
                                        className="box-actions--item box-actions--item-green"
                                        style={{ cursor: 'default' }}
                                    >
                                        <i className="nx nx-check"></i>
                                    </div>
                                ) : (
                                    '-'
                                )}
                            </tr>
                        );
                    }
                    return <tr key={c.name}>{s[c.name]}</tr>;
                }
            });
            return (
                <td
                    key={s.id}
                    className={`${
                        this.state.hoverPlan === s.title.plan ? 'active' : ''
                    }`}
                >
                    {value}
                </td>
            );
        });
    };

    render() {
        return (
            <div className="plan-container">
                <table className="plan-table">
                    <thead className="plan-table-colHeader">
                        <td>
                            <th>
                                <img
                                    src={`${STATIC_STORAGE_URL}/img/portal/plan.png`}
                                    alt="subscription"
                                />
                                <div style={{ margin: '40px 0 20px 0' }}>
                                    {this.renderPaymentType()}
                                </div>
                            </th>
                        </td>
                        {this.renderColumnHeader()}
                    </thead>
                    <tbody>
                        <td>{this.renderRowHeader()}</td>
                        {this.renderTableData()}
                    </tbody>
                </table>
                {this.state.maxShow !== planColumns.length && (
                    <div
                        className="plan-table-collaspe"
                        onClick={(e) =>
                            this.setState({ maxShow: planColumns.length })
                        }
                    >
                        more features &nbsp; <i className="nx nx-arrow-d"></i>{' '}
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (store: IApplicationState) => {
    const {
        projectReducer: { currentProject },
        router: { location }
    } = store;
    return {
        currentProject,
        location
    };
};

const mapDispatchToProps = (dispatch) => ({
    changePath: (path) => {
        dispatch(push(path));
    }
});

export default NotifyHOC(
    connect(mapStateToProps, mapDispatchToProps)(PlanningBilling)
);
